import { createRouter, createWebHistory } from "vue-router";
import { ReviseMeta } from "@/util/meta";
import { deviceType } from "@/util/base";

function createAdRoutes(platforms) {
  return platforms.flatMap(({ prefix, versions, componentMap }) =>
    versions.map((version) => ({
      path: `${prefix}-${version}`,
      name: `${prefix}-${version}`,
      component: () =>
        import(`./views/down/${componentMap[version] || version}.vue`),
    }))
  );
}

const adRoutesVersions = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "B2",
  "C2",
  "D2",
];

// 特殊映射;
const adRoutesComponentMap = { L: "L", M: "M" };

const adRoutes = createAdRoutes([
  {
    prefix: "TT", // 抖音
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  },
  {
    prefix: "FB", // 脸书
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  },
  {
    prefix: "GG", // 谷歌
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  },
  {
    prefix: "tw", // 推特
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  },
  {
    prefix: "TW", // 推特
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  },
]);

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // 入口页面 预约期 官网先展示预约
    {
      path: "/",
      component: () => import("./views/gw/index.vue"),
      meta: {
        title: "",
        keywords: "",
        description: "",
      },
    },
    {
      path: "/m",
      component: () => import("./views/gw/index.vue"),
      meta: {
        title: "",
        keywords: "",
        description: "",
      },
    },
    // 官网测试链接
    {
      path: "/home",
      component: () => import("./views/gw/index.vue"),
      meta: {
        title: "",
        keywords: "",
        description: "",
      },
    },
    {
      path: "/home/m",
      component: () => import("./views/gw/index.vue"),
      meta: {
        title: "",
        keywords: "",
        description: "",
      },
    },
    {
      path: "/news",
      component: () => import("./views/gw/news.vue"),
      meta: {
        title: "",
        keywords: "",
        description: "",
      },
    },
    {
      path: "/news/m",
      component: () => import("./views/gw/news.vue"),
      meta: {
        title: "",
        keywords: "",
        description: "",
      },
    },
    {
      path: "/content",
      component: () => import("./views/gw/content.vue"),
      meta: {
        title: "",
        keywords: "",
        description: "",
      },
    },
    {
      path: "/content/m",
      component: () => import("./views/gw/content.vue"),
      meta: {
        title: "",
        keywords: "",
        description: "",
      },
    },
    // 预约
    {
      path: "/pre",
      component: () => import("./views/gw/index.vue"),
      meta: {
        title: "",
        keywords: "",
        description: "",
      },
    },
    {
      path: "/pre/m",
      component: () => import("./views/gw/index.vue"),
      meta: {
        title: "",
        keywords: "",
        description: "",
      },
    },
    // 预约FB
    {
      path: "/pre/FB",
      component: () => import("./views/gw/index.vue"),
      meta: {
        title: "",
        keywords: "",
        description: "",
      },
    },
    {
      path: "/pre/FB/m",
      component: () => import("./views/gw/index.vue"),
      meta: {
        title: "",
        keywords: "",
        description: "",
      },
    },
    // 预约GG
    {
      path: "/pre/GG",
      component: () => import("./views/gw/index.vue"),
      meta: {
        title: "",
        keywords: "",
        description: "",
      },
    },
    {
      path: "/pre/GG/m",
      component: () => import("./views/gw/index.vue"),
      meta: {
        title: "",
        keywords: "",
        description: "",
      },
    },
    // 预约TT
    {
      path: "/pre/TT",
      component: () => import("./views/gw/index.vue"),
      meta: {
        title: "",
        keywords: "",
        description: "",
      },
    },
    {
      path: "/pre/TT/m",
      component: () => import("./views/gw/index.vue"),
      meta: {
        title: "",
        keywords: "",
        description: "",
      },
    },
    // 协议
    // 东南亚
    {
      path: "/protocol",
      component: () => import("./views/protocol.vue"),
    },
    // 欧美
    {
      path: "/protocol-na",
      component: () => import("./views/na-protocol.vue"),
    },
    // 下载
    {
      path: "/down",
      meta: {
        title: "",
        keywords: "",
        description: "",
      },
      children: adRoutes,
    },
    // 404
    {
      path: "/:pathMatch(.*)*",
      component: () => import("../../components/404.vue"),
    },
  ],
});
router.beforeEach((to, from, next) => {
  // 路由发生变化改变 description 和 keyword
  ReviseMeta(to.meta.title, to.meta.keywords, to.meta.description);

  // 定义特殊页面白名单，使用正则表达式匹配通配符
  const specialPages = [/^\/down(\/.*)?$/];

  // 检查当前路径是否在特殊页面白名单中
  const isSpecialPage = specialPages.some((pattern) => pattern.test(to.path));

  // 如果是特殊页面，直接调用 next()
  if (isSpecialPage) {
    next();
    return;
  }

  const isWap = deviceType() == "wap";

  // 定义PC端和移动端路径
  let pcPath = to.path.replace(/\/m$/, "");
  let wapPath = pcPath.endsWith("/") ? `${pcPath}m` : `${pcPath}/m`;

  // 根据设备类型跳转，避免重复添加或删除斜杠
  if (isWap && !to.path.endsWith("/m")) {
    next({ path: wapPath, query: to.query });
  } else if (!isWap && to.path.endsWith("/m")) {
    next({ path: pcPath, query: to.query });
  } else {
    next();
  }
});

export default router;
